interface Props {
  color?: string
  width?: number
  height?: number
}

export const LoadingIcon = ({ color = '#6F6F6F', width = 22, height = 22 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 11C1 16.5229 5.47715 21 11 21C16.5229 21 21 16.5229 21 11C21 5.47715 16.5229 1 11 1"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
